import { asyncToGenerator as _asyncToGenerator } from './_virtual/_rollupPluginBabelHelpers.js';
import { matchPath } from 'react-router-dom';
import _regeneratorRuntime from 'regenerator-runtime';
import { isLoadableComponent } from './utils.esm.js';

/**
 * This helps us to make sure all the async code is loaded before rendering.
 */

function ensureReady(_x, _x2) {
  return _ensureReady.apply(this, arguments);
}

function _ensureReady() {
  _ensureReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(routes, pathname) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all(routes.map(function (route) {
              var match = matchPath(pathname || window.location.pathname, route);

              if (match && route && route.component && isLoadableComponent(route.component) && route.component.load) {
                return route.component.load();
              }

              return undefined;
            }));

          case 2:
            return _context.abrupt("return", Promise.resolve(window.__SERVER_APP_STATE__));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ensureReady.apply(this, arguments);
}

export { ensureReady };
//# sourceMappingURL=ensureReady.esm.js.map
